import { Company } from "../../domain/model/company";
import { Project } from "../../domain/model/project";
import { TCompanyWithProjectID } from "../../domain/repository/company_repository";

// client project detail
interface IGetProjectDetailByClientResponse {
  project?: Project;
  company?: Company;
}
class GetProjectDetailByClientResponse
  implements IGetProjectDetailByClientResponse
{
  public project: Project;
  public company: Company;
}

interface ICreateProjectDetailByClientResponse {
  project?: Project;
  company?: Company;
}
class CreateProjectDetailByClientResponse
  implements ICreateProjectDetailByClientResponse
{
  public project: Project;
  public company: Company;
}

interface IUpdateProjectDetailByClientResponse {
  project?: Project;
}
class UpdateProjectDetailByClientResponse
  implements IUpdateProjectDetailByClientResponse
{
  public project: Project;
}

// client project list

interface IGetAllProjectListByClientResponse {
  projects?: Project[];
  projectCount?: number | Long;
  companies?: Company[];
}
class GetAllProjectListByClientResponse
  implements IGetAllProjectListByClientResponse
{
  public projects: Project[];
  public projectCount: number | Long;
  public companies: Company[];
}

interface ICopyProjectResponse {
  project: Project;
}
class CopyProjectResponse implements ICopyProjectResponse {
  public project: Project;
}

// customer project detail

interface IGetProjectByCustomerResponse {
  project?: Project;
  company?: Company;
  entryProjects?: Project[];
}
class GetProjectByCustomerResponse implements IGetProjectByCustomerResponse {
  public project: Project;
  public company: Company;
  public entryProjects: Project[];
}

interface IGetEntryProjectsByCustomerResponse {
  entryProjects?: Project[];
}
class GetEntryProjectsByCustomerResponse
  implements IGetEntryProjectsByCustomerResponse
{
  public entryProjects: Project[];
}

// customer project list
interface IGetEntryNumOrderProjectListByCustomerResponse {
  newlyArrivedProjects?: Project[];
  companiesWithNewlyArrivedProjectID?: TCompanyWithProjectID[];
  entryNumOrderProjects?: Project[];
  companiesWithEntryNumOrderProjectID?: TCompanyWithProjectID[];
}
class GetEntryNumOrderProjectListByCustomerResponse
  implements IGetEntryNumOrderProjectListByCustomerResponse
{
  public newlyArrivedProjects: Project[];
  public companiesWithNewlyArrivedProjectID: TCompanyWithProjectID[];

  public entryNumOrderProjects: Project[];
  public companiesWithEntryNumOrderProjectID: TCompanyWithProjectID[];
}

interface IGetProjectListByCustomerResponse {
  projects?: Project[];
  companiesWithProjectID?: TCompanyWithProjectID[];
  projectCount?: number | Long;
}
class GetProjectListByCustomerResponse
  implements IGetProjectListByCustomerResponse
{
  public projects: Project[];
  public companiesWithProjectID: TCompanyWithProjectID[];
  public projectCount: number | Long;
}

interface IGetProjectCountByCustomerResponse {
  projectCount?: number;
}
class GetProjectCountByCustomerResponse
  implements IGetProjectCountByCustomerResponse
{
  public projectCount: number;
}

interface ISearchProjectListByCustomerResponse {
  projects?: Project[];
  companiesWithProjectID?: TCompanyWithProjectID[];
  projectCount?: number | Long;
}
class SearchProjectListByCustomerResponse
  implements ISearchProjectListByCustomerResponse
{
  public projects: Project[];
  public companiesWithProjectID: TCompanyWithProjectID[];
  public projectCount: number | Long;
}

export {
  CopyProjectResponse,
  CreateProjectDetailByClientResponse,
  // client project list
  GetAllProjectListByClientResponse,
  // customer project list
  GetEntryNumOrderProjectListByCustomerResponse,
  GetEntryProjectsByCustomerResponse,
  // customer project detail
  GetProjectByCustomerResponse,
  GetProjectCountByCustomerResponse,
  // client project detail
  GetProjectDetailByClientResponse,
  GetProjectListByCustomerResponse,
  SearchProjectListByCustomerResponse,
  UpdateProjectDetailByClientResponse,
};



// WEBPACK FOOTER //
// ./src/presentation/response/project_response.ts